import React from 'react'
import "./White_btn.css"
import { Button } from 'react-bootstrap'

function White_btn({ btnText, onClick }) {
    return (
        <>
            <section className='White_btn_holder'>

                <Button className="White_btn" onClick={onClick}>{btnText}  </Button>

            </section>
        </>
    )
}

export default White_btn